import React, { useContext, useState, useEffect } from "react";
import Card from "../../component/Card";
import Form from "../../component/Form";
import withFormLogic from "../../hoc/withFormLogic";
import withPostFetch from "../../hoc/withPostFetch";
import withReference from "../../hoc/withReference";
import { SkdrContext } from "../Context";

import {
  searchVisitReportGroup,
  // getClinics,
  // getAccidents,
  // getPaymentTypes,
  // getWorkAreas,
  fetchSexs,
  // getICD,
} from "../DataProvider";
import validationRules from "../validationRules";
import apiService from "apiService";
import moment from "moment";
import { formatDate } from "helper/helper";

const FilterForm = ({
  field,
  onChangeHandler,
  dateOnChange,
  reactSelectHandler,
  resetField,
  submitHandler,
  post,
  data,
  validation,
  onLoad,
}) => {
  const { insertStore } = useContext(SkdrContext);
  const [type, setType] = useState("");
  const [typeOption, setTypeOption] = useState([]);
  const [pkm, setpkm] = useState([]);
  const [penyakit_, setPenyakit] = useState([]);
  const [reporttype, setReportType] = useState([]);
  const [reportTypevalue, setreportTypevalue] = useState([]);

  const getType = async () => {
    const res = await apiService.get("/management/icd_group/read");
    let option = [];
    // let icd = [];
    if (res.code === 200) {
      res.data.data.map((response) => {
        option.push({ value: response.id, label: response.name });
        // icd[`${response.name}`] = new Array();
        // response.icd_map.map((res) => {
        //   icd[`${response.name}`].push({
        //     value: res.code,
        //     label: `${res.code}-${res.name}`,
        //   });
        // });
      });
      setTypeOption(option);
      // setIcdGroup(icd);
      // console.log(icd);
    }
  };
  const getTypeReport = async () => {
    const res = await apiService.get("/management/report_group_type");
    let option = [];
    let penyakit = [];

    if (res.code === 200) {
      res.data?.map((response) => {
        option.push({ value: response.id, label: response.name });
        penyakit[`${response.name}`] = new Array();
        response.penyakit_map.map((res) => {
          penyakit[`${response.name}`].push({
            value: res.id,
            label: `${res.name}`,
          });
        });
        console.log(response);
      });
      setReportType(option);
      setPenyakit(penyakit);
    }
  };

  // const getContinue = async () => {
  //   const res = await API.get("management/continues/read/1");
  //   if (res.code === 200) {
  //     setRefContinue(res.data);
  //   } else {
  //     console.error("Cannot load data from remote source");
  //   }
  // };

  const fetchPuskesmasProfile = async () => {
    try {
      const res = await apiService.get("/management/profiles/read");
      let opt = [];
      if (res.code === 200) {
        res.data.map((response) => {
          opt.push({ value: response.code, label: response.name });
        });
        setpkm(opt);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getType();
    fetchPuskesmasProfile();
    getTypeReport();
  }, []);
  return (
    <div>
      <Card.SubHeaderWithCollapse header="Filter">
        <Card.Body>
          <Form.Row>
            <Form.Column lg={6} xs={12}>
              <Form.ReactSelect
                label="Tipe Laporan"
                options={reporttype}
                value={reportTypevalue}
                name="type"
                placeholder="Pilih..."
                onChange={(e) => {
                  setreportTypevalue(e);
                  reactSelectHandler(penyakit_[e.label], { name: "penyakit" });
                }}
              />
            </Form.Column>
            <Form.Column lg={6} xs={12}>
              <Form.ReactSelect
                label="Kelompok Penyakit"
                options={typeOption}
                value={field.penyakit_value}
                name="penyakit"
                isMulti={true}
                placeholder="Pilih..."
                onChange={reactSelectHandler}
              />
            </Form.Column>
          </Form.Row>
          <Form.Row>
            <Form.Column lg={3} xs={12}>
              <Form.Select
                label="Periode"
                name="periode"
                value={field.periode}
                options={[{ value: "Hari", label: "Hari" }]}
                onChange={onChangeHandler}
              />
            </Form.Column>
            <Form.Column lg={2} xs={12}>
              <Form.DatePicker
                size="sm"
                placeholder="Dari"
                name="start_date"
                value={field.start_date_value}
                onChange={dateOnChange}
              />
            </Form.Column>
            <Form.Column lg={2} xs={12}>
              <Form.DatePicker
                size="sm"
                placeholder="Sampai"
                name="end_date"
                value={field.end_date_value}
                onChange={dateOnChange}
              />
            </Form.Column>
          </Form.Row>
          <Form.Row>
            <Form.Column lg={2} xs={12}>
              <button
                className="btn btn-primary btn-block"
                disabled={onLoad}
                onClick={() =>
                  submitHandler(validation, field, (params) => {
                    insertStore({ onLoad: true, params });
                    post(params, (response) =>
                      insertStore({ dataKunjungan: response, onLoad })
                    );
                  })
                }
              >
                Tampilkan
              </button>
            </Form.Column>
            <Form.Column lg={2} xs={12}>
              <button
                className="btn btn-secondary btn-block"
                onClick={resetField}
              >
                Reset
              </button>
            </Form.Column>
          </Form.Row>
        </Card.Body>
      </Card.SubHeaderWithCollapse>
    </div>
  );
};

const field = {
  type: [],
  penyakit: [],
  start_date:formatDate(new Date()),
  end_date:formatDate(new Date()),
  periode: "Hari",
  limit: 100000,
};

export default withReference(
  [
    // getClinics(),
    // getAccidents(),
    // getPaymentTypes(),
    // getWorkAreas(),
    fetchSexs(),
  ],
  // "clinics", "accidents", "payment_types", "work_areas",
  ["sexs"]
)(
  withPostFetch((params) => searchVisitReportGroup(params))(
    withFormLogic(field, validationRules)(FilterForm)
  )
);
